import React, { FC, useEffect, useRef } from 'react';
import { IUserRepairWorks } from '../../../models/UserInfo';
import { RepairWork } from './variants/RepairWork';
import { TechWork } from './variants/TechWork';
import { DateVOv2 } from '../../../core/DateVOv2';
import { handleTechWorkAnalytics } from '../../../utils';

interface TechnicalWorksProps {
  work: IUserRepairWorks;
}

export const TechnicalWorks: FC<TechnicalWorksProps> = ({ work }) => {
  const currentMonth = new DateVOv2().getCurrentMonth();
  const isSentAnalytics = useRef(false);

  useEffect(() => {
    if (isSentAnalytics.current) return;
    isSentAnalytics.current = true;

    handleTechWorkAnalytics(work.id);
  }, [work.id]);

  if (currentMonth % 2 === 0) {
    return <RepairWork work={work} />;
  }
  return <TechWork work={work} />;
};
